import { render, staticRenderFns } from "./TarjetaMiBonoRI.vue?vue&type=template&id=6907b026&scoped=true"
import script from "./TarjetaMiBonoRI.vue?vue&type=script&lang=js"
export * from "./TarjetaMiBonoRI.vue?vue&type=script&lang=js"
import style0 from "./TarjetaMiBonoRI.vue?vue&type=style&index=0&id=6907b026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6907b026",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCard,VCardText,VCol,VIcon,VProgressLinear,VRow})
